import type { PropsWithChildren } from "react";
import { useEffect, useEffectEvent } from "react";

type ModalProps = PropsWithChildren<{
  title: string;
  onClose: () => void;
  wide?: boolean;
}>;

export function Modal({ children, title, onClose, wide = false }: ModalProps) {
  const handleClose = useEffectEvent(onClose);

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") {
        handleClose();
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className={`modal ${wide ? "modal--wide" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal__header">
          <h3>{title}</h3>
          <button className="ghost-button ghost-button--sm" type="button" onClick={onClose}>
            Chiudi
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
